import React, { useState, useEffect } from "react";
import { InfoArea } from "../styles";
import Select from "../../../../components/selectField";
import XIcon from "assets/buyers/xIcon";
import IconButton from "@material-ui/core/IconButton";
import { SelectingTypeOptions } from "components/addFinancialPopup/remainingTypes";

export const InsuranceTypeAndNamePick = ({
  insuranceType,
  index,
  object,
  setObject,
  filteredData,
  removeInsuranceType,
  isEsub = false,
  esubId = null,
}) => {
  const [insuranceCompanyList, setInsuranceCompanyList] = useState([]);
  const [remainingType, setRemainingType] = useState([]);
  const [disabled, setDisable] = useState(true);
  const currentState = object?.state[index];

  useEffect(() => {
    const matchedType = insuranceType?.find((v) => v.short_form === currentState.type)?.type;
    const temp = filteredData.filter((d) => {
      if (d.insuranceDetails?.state) {
        return Object.values(d.insuranceDetails.state).some((s) => s.type === matchedType);
      }
      return false;
    });
    setInsuranceCompanyList(temp);
    setDisable(currentState.type === null);
    setRemainingType(SelectingTypeOptions(object, insuranceType));
  }, [object, filteredData]);

  const handleTypeUpdate = (val) => {
    object.state[index].type = val;
    setObject({ ...object });
  };

  const handleDataUpdate = (val) => {
    const company = filteredData.find((i) => (isEsub ? i.esub_id : i.ref_id) === val);
    let dataObj = { ...company };
    if (isEsub) {
      // ensure correct key for e-sub flow
      if (esubId) dataObj.esub_id = esubId;
      delete dataObj.ref_id; // remove ref_id so only esub_id is kept
    } else {
      // standard flow – keep ref_id only
      delete dataObj.esub_id;
    }
    object.state[index].data = dataObj;
    setObject({ ...object });
  };

  return (
    <div style={{ width: "100%", display: "flex" }}>
      <InfoArea marginTop="0px" width="50%" style={{ marginRight: "20px" }}>
        <Select
          label="Insurance Type"
          options={remainingType.map((it) => ({ value: it.short_form, label: it.type }))}
          value={insuranceType.find((v) => v.short_form === object?.state[index]?.type)?.type}
          setValue={handleTypeUpdate}
          validateFunc={(item) => Boolean(item)}
          noCheckIcon
          showDropdownIndicator
        />
      </InfoArea>
      <InfoArea marginTop="0px" width="50%">
        <Select
          label=" Company Name"
          options={insuranceCompanyList.map((it) => ({ value: isEsub ? it.esub_id : it.ref_id, label: it.company_name }))}
          value={object?.state[index]?.data?.company_name}
          setValue={handleDataUpdate}
          validateFunc={(item) => Boolean(item)}
          noCheckIcon
          showDropdownIndicator
          disabled={disabled}
        />
      </InfoArea>
      <InfoArea marginTop="45px">
        <IconButton onClick={() => removeInsuranceType(index)}>
          <XIcon />
        </IconButton>
      </InfoArea>
    </div>
  );
};

export default InsuranceTypeAndNamePick;
